class FeaturedCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.feeds = this.querySelectorAll('featured-collections-feed');
    this.controls = this.querySelectorAll(
      '[data-controls-prev], [data-controls-next]'
    );

    this.controls.forEach((control) =>
      control.addEventListener('click', this.handleOnControlClick.bind(this))
    );
  }

  handleOnControlClick(event) {
    const activeFeed = Array.from(this.feeds).find(
      (feed) => !feed.classList.contains('hidden')
    );
    const slider = activeFeed.slider;

    if (!slider) return;

    slider[
      event.target.hasAttribute('data-controls-prev')
        ? 'slidePrev'
        : 'slideNext'
    ]();
  }
}

customElements.define('featured-collections', FeaturedCollections);
